import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=03d9b622&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d9b622')) {
      api.createRecord('03d9b622', component.options)
    } else {
      api.reload('03d9b622', component.options)
    }
    module.hot.accept("./MainPage.vue?vue&type=template&id=03d9b622&", function () {
      api.rerender('03d9b622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainPage.vue"
export default component.exports